// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

button.random {
  background-color: #5a7d15;
  color: white;
  padding: 10px;
  margin-right: 10px;
}

.back-link {
  text-align: center;
  padding-bottom: 10px;
}

.random-text {
  color: var(--dunkelgruen);
  text-decoration: underline;
  text-underline-offset: 4px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 10px;
  display: inline-block;
}

.random-text svg {
  font-size: 1.4rem;
  position: relative;
  top: 4px;
  margin-right: 4px;
}

.bewerbung-title {
  font-size: 32px;
  color: var(--dunkelgruen);
  text-transform: uppercase;
  margin-bottom: 12px;
  text-align: left;
}


.bewerbung-button {
  background-color: transparent;
  border: 2px solid var(--dunkelgruen);
  color: var(--dunkelgruen);
  padding: 16px;
  width: 100%;
  border-radius: 20px;
  font-weight: normal;
  font-size: 1.4rem;
  text-transform: uppercase;
  margin-top: 12px;
}

.bewerbung-button:disabled {
  background-color: transparent;
  color: var(--placeholder);
  border-color: var(--placeholder);
}

.page2-form-actions {
  margin-top: 12px;
  margin-bottom: 20px;
}

.bottom-space {
  height: 20px;
}

.absenden-button {
  background-color: var(--dunkelgruen);
  color: var(--blassgruen);
  padding: 16px;
  width: 100%;
  border: none;
  border-radius: 20px;
  font-weight: normal;
  font-size: 1.4rem;
  text-transform: uppercase;
  margin-bottom: 12px;
}

.success-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--dunkelgruen);
  height: 50vh;
  text-align: center;
}

.success-links {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  align-items: center;
}

.menu-icon {
  font-size: 1.2rem;
  position: relative;
  top: 2px;
  margin-right: 4px;
  color: var(--dunkelgruen);
}

.add-icon {
  font-size: 1.2rem;
  position: relative;
  top: 2px;
  margin-right: 4px;
  color: var(--dunkelgruen);
}

.success-link {
  color: var(--dunkelgruen);
  display: flex;
  align-items: center;
  cursor: pointer;
}

.success-link .link-text {
  text-decoration: underline;
  text-underline-offset: 4px;
}

.success-message h2 {
  margin-bottom: 2rem;
  font-size: 1.8rem;
  color: var(--dunkelgruen);
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/jobs/bewerbung/Bewerbung.css"],"names":[],"mappings":";;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":["\n\nbutton.random {\n  background-color: #5a7d15;\n  color: white;\n  padding: 10px;\n  margin-right: 10px;\n}\n\n.back-link {\n  text-align: center;\n  padding-bottom: 10px;\n}\n\n.random-text {\n  color: var(--dunkelgruen);\n  text-decoration: underline;\n  text-underline-offset: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  margin-top: 10px;\n  display: inline-block;\n}\n\n.random-text svg {\n  font-size: 1.4rem;\n  position: relative;\n  top: 4px;\n  margin-right: 4px;\n}\n\n.bewerbung-title {\n  font-size: 32px;\n  color: var(--dunkelgruen);\n  text-transform: uppercase;\n  margin-bottom: 12px;\n  text-align: left;\n}\n\n\n.bewerbung-button {\n  background-color: transparent;\n  border: 2px solid var(--dunkelgruen);\n  color: var(--dunkelgruen);\n  padding: 16px;\n  width: 100%;\n  border-radius: 20px;\n  font-weight: normal;\n  font-size: 1.4rem;\n  text-transform: uppercase;\n  margin-top: 12px;\n}\n\n.bewerbung-button:disabled {\n  background-color: transparent;\n  color: var(--placeholder);\n  border-color: var(--placeholder);\n}\n\n.page2-form-actions {\n  margin-top: 12px;\n  margin-bottom: 20px;\n}\n\n.bottom-space {\n  height: 20px;\n}\n\n.absenden-button {\n  background-color: var(--dunkelgruen);\n  color: var(--blassgruen);\n  padding: 16px;\n  width: 100%;\n  border: none;\n  border-radius: 20px;\n  font-weight: normal;\n  font-size: 1.4rem;\n  text-transform: uppercase;\n  margin-bottom: 12px;\n}\n\n.success-message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: var(--dunkelgruen);\n  height: 50vh;\n  text-align: center;\n}\n\n.success-links {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  align-items: center;\n}\n\n.menu-icon {\n  font-size: 1.2rem;\n  position: relative;\n  top: 2px;\n  margin-right: 4px;\n  color: var(--dunkelgruen);\n}\n\n.add-icon {\n  font-size: 1.2rem;\n  position: relative;\n  top: 2px;\n  margin-right: 4px;\n  color: var(--dunkelgruen);\n}\n\n.success-link {\n  color: var(--dunkelgruen);\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.success-link .link-text {\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n.success-message h2 {\n  margin-bottom: 2rem;\n  font-size: 1.8rem;\n  color: var(--dunkelgruen);\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
